require("utility/carousel.scss");

class Carousel extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { displayIndex: 0 };
	}

	displayPrevious(e) {
		$wr.nope(e)
		var newIndex = this.state.displayIndex - 1;
		if (newIndex == -1) {
			newIndex = this.props.displayItems.length - 1;
		}
		this.setState({ displayIndex: newIndex },this.onChange.bind(this));
	}
	displayNext(e) {
		$wr.nope(e)
		var newIndex = this.state.displayIndex + 1;
		if (newIndex == this.props.displayItems.length) {
			newIndex = 0;
		}
		this.setState({ displayIndex: newIndex },this.onChange.bind(this));
	}
	onChange() {
		if (this.props.onIndexChange) {
			this.props.onIndexChange(this.state.displayIndex)
		}
	}

	render() {
		var leftArrowPath = require("misc/arrow-left.png");
		var leftArrow = (
			<img src={ leftArrowPath } onClick={ this.displayPrevious } className="leftArrow" />
		);
		var rightArrowPath = require("misc/arrow-right.png");
		var rightArrow = (
			<img src={ rightArrowPath } onClick={ this.displayNext } className="rightArrow" />
		);
		return (
			<div className="carousel">
				{ leftArrow }
				{ rightArrow }
				<div className="displayContent">
					{ this.props.displayItems[this.state.displayIndex] }
				</div>
			</div>
		);
 	}
};

Carousel.propTypes = StrictPropTypes({
	// array of display objects to show in carousel
	displayItems: PropTypes.array.isRequired,
	onIndexChange: PropTypes.func

});

module.exports = Carousel;



// WEBPACK FOOTER //
// ./modules/components/utility/Carousel.js